import script from "./BeforeAfterSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./BeforeAfterSlider.vue?vue&type=script&setup=true&lang=js"

import "./BeforeAfterSlider.vue?vue&type=style&index=0&id=29e5a02b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e5a02b"]])

export default __exports__